import { render, staticRenderFns } from "./wxuserdetail.vue?vue&type=template&id=3d370d3a&"
import script from "./wxuserdetail.vue?vue&type=script&lang=js&"
export * from "./wxuserdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports